import { render, staticRenderFns } from "./ListFooter.vue?vue&type=template&id=6ac17d83&"
import script from "./ListFooter.vue?vue&type=script&lang=js&"
export * from "./ListFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports